"use client"

import Image from "next/image";
import UploadModal from "../shared/uploadModal";
import { useState } from "react";

interface ChangePDFProps {
    title: string,
    subtitle: string,
    image: string,
}

export default function ChangePDF(props: ChangePDFProps) {

    const [showModal, setShowModal] = useState(false);

    function showUpload() {

        setShowModal(true);
    }

    function hideModal() {
        setShowModal(false);
    }

    return (
        <>
            <section className="convert">
                <div className="container">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="mb-300 mb-md-0">
                                <img height={300} width={300} className="convert__img img-fluid" src={props.image} alt="img" />
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="content-box text-center">
                                <h2 className="main-heading">{props.title}</h2>
                                <p className="content-box__desc sub-desc fs-3">{props.subtitle}</p>
                            </div>
                            <div className="text-center mt-300 mt-lg-450">
                                <button onClick={showUpload} className="mybtn mybtn--primary mybtn--bg px-500">UPLOAD YOUR PDF TO CONVERT</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <UploadModal
                title={"Convert PDF"}
                open={showModal}
                onClose={hideModal}
                buttonText="Select file..."
            />
        </>
    );
}
